export default "__VITE_ASSET__50a9039a__"